// Debug helper
window.log = function() { return console.log(arguments); };

window.call = fn => fn();



// WEBPACK FOOTER //
// ./app/webpack/frontend/config/helpers.js